import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('jv-empty-state')
export class JvEmptyState extends LitElement {
  static styles = css`
    :host {
      display: block;
      text-align: center;
      padding: var(--jv-space-7) var(--jv-space-4);
      color: var(--jv-color-muted);
      border: var(--jv-border-w) dashed var(--jv-color-border-soft);
    }
    h2 {
      margin: 0 0 0.5rem;
      color: var(--jv-color-text);
      font-size: var(--jv-fs-xl);
    }
  `;

  @property() heading = '';

  render() {
    return html`
      <h2>${this.heading}</h2>
      <p><slot></slot></p>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'jv-empty-state': JvEmptyState;
  }
}
